import { FormStickyActions, FormSpacer } from '@/components/forms';
import type { SubscriptionPlanFormData } from '../types';
import { SubscriptionPlanFormFields, buildPlanFormState } from './SubscriptionPlanFormFields';

interface SubscriptionPlanCreateTabProps {
  loading: boolean;
  onFinish: (v: SubscriptionPlanFormData) => Promise<void>;
}

export function SubscriptionPlanCreateTab({ loading, onFinish }: SubscriptionPlanCreateTabProps) {
  const initial = buildPlanFormState();

  return (
    <SubscriptionPlanFormFields
      key="create"
      isEdit={false}
      formLoading={loading}
      initialState={initial}
      renderFooter={(submit, isLoading) => (
        <>
          <FormSpacer />
          <form onSubmit={(e) => { e.preventDefault(); submit(); }}>
            <FormStickyActions
              primaryLabel="Создать"
              onPrimary={submit}
              isPending={isLoading}
              pendingLabel="Создание..."
            />
          </form>
        </>
      )}
      onFinish={onFinish}
    />
  );
}
